export default __webpack_public_path__ + "static/book-billing-bd367c2c423a193a7ee697f409b4c2dc.svg";